<template>
  <vuex-table :fields="fields" :filter_items="filter_items" :show_per_page="false" table_store="autocaller_v2/webhook/table">
    <template slot="name" slot-scope="{ item }">
      {{ item.name }}
    </template>
    <template slot="active" slot-scope="{ item }">
      <switch-status :id="item.id" :key="item.id" :value="item" />
    </template>
    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span class="dropdown-item-icon dropdown-item-icon--edit" @click="edit(item)">
          {{ $t('shared.component.table.action.edit') }}
        </span>
        <span
          v-if="!item.active"
          class="dropdown-item-icon dropdown-item-icon--trash"
          @click="remove(item)"
        >
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import SwitchStatus from './campaigns-editbale-status';
  import { WebhookModalService } from '@autocaller_v2/modals/WebhookModalService';
  import { mapActions, mapGetters } from 'vuex';
  import { DATA } from '@/plugins/vuex-async-pagginate';
  export default {
    components: { SwitchStatus },
    computed: {
      ...mapGetters('autocaller_v2/webhook/table', { items: DATA }),
      filter_items() {
        let filter = this.items.map(item => ({ ...item }));
        Object.keys(filter).forEach( key => filter[key].type = this.$t(`autocaller_v2.webhook.webhook_type.${filter[key].type}`) );
        return filter;
      },
      fields() {
        return [
          {
            key: 'type',
            label: this.$t('autocaller_v2.campaign.field.type'),
            sortable: true
          },
          {
            key: 'url',
            label: this.$t('autocaller_v2.webhook.field.url'),
            sortable: true,
            formatter: value => (Array.isArray(value) ? value.join(', ') : value)
          },
          {
            key: 'updated_at',
            label: this.$t('shared.component.table.field.updated_at'),
            sortable: true
          },
          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center',
            thStyle: { width: '120px' }
          }
        ];
      }
    },
    methods: {
      ...mapActions('autocaller_v2/webhook/table', ['getAsyncData']),
      remove(item) {
        WebhookModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      },
      edit(item) {
        WebhookModalService.edit(item.id, item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>
